import { post } from 'communication/httpClient';
import { LoggerMessage } from './types';

window.addEventListener('error', (e) => {
  const data: LoggerMessage = {
    logType: 'error',
    logMessage: {
      message: e.error.message,
      stack: e.error.stack,
    },
  };
  if(window.location.origin === process.env.REACT_APP_SERVER_URL)
    post('/api/logger', data);
});
